import React from 'react';
import { motion } from 'framer-motion';

const FlexAndConnectSection = () => {
    // Animation Variants
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="w-full py-[60px] md:py-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="flex flex-col md:flex-row bg-white border border-[#01386A45] overflow-hidden group transition-shadow duration-300"
                >
                    {/* Image Half */}
                    <div className="w-full md:w-1/2 overflow-hidden h-[300px] md:h-auto min-h-[300px] md:min-h-[300px]">
                        <img
                            src="/assets/work/img2.png"
                            alt="Flex and connect infinity shape"
                            className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105"
                        />
                    </div>

                    {/* Text Half */}
                    <div className="w-full md:w-1/2 p-[30px] md:p-[60px] lg:p-[80px] flex flex-col justify-center">
                        <h2 className="text-[20px] lg:text-[30px] font-sora font-[600] text-[#01386A] tracking-tight mb-[16px] md:mb-[20px] transition-transform duration-300 group-hover:-translate-y-1">
                            Flex and connect
                        </h2>
                        <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.7] max-w-[520px]">
                            At Mobikode, flexibility isn’t just about your workspace, it’s about trusting you to work in a way that suits you best. We encourage real connections, open collaboration, and believe great ideas come when people feel supported and valued.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default FlexAndConnectSection;